import '../css/containers/KIndexChartContainer.scss'
import { connect, ConnectedProps } from 'react-redux'
import React, { FC, useEffect } from 'react'
import { fetchPredictedKIndex, fetchPredicted3DayKIndex, fetchKIndex } from '../actions/kIndex'
import Chart from '../components/Chart'
import { YELLOW, RED, ORANGE, GREEN } from '../constants/colors'
import { KPI_HIGH, KPI_MODERATE, KPI_MEDIUM } from '../constants/thresholds'
import { K_INDEX_URL, PREDICTED_3_DAY_K_INDEX_URL, PREDICTED_K_INDEX_URL } from '../constants/urls'

const K_INDEX_SETTINGS = {
  softMax: 10,
  softMin: 0,
  allowDecimals: false,
}

const K_INDEX_ZONES = [
  {
    value: KPI_MEDIUM,
    color: GREEN,
  },
  {
    value: KPI_MODERATE,
    color: YELLOW,
  },
  {
    value: KPI_HIGH,
    color: ORANGE,
  },
  {
    color: RED,
  },
]

const K_INDEX_CHART = {
  type: 'column',
  zones: K_INDEX_ZONES,
  color: YELLOW,
}

// ToDo: This is here only to get the typing for this.point, there surely is a better way
const dataLabels: { enabled: boolean; formatter: () => string; point?: any } = {
  enabled: true,
  formatter: function (): string {
    return this.point.g ? this.point.g : ''
  },
}

const KIndexChartContainer: FC<PropsFromRedux> = (props) => {
  const { fetchPredicted3DayKIndex, fetchPredictedKIndex, fetchKIndex } = props
  useEffect(() => {
    fetchPredicted3DayKIndex(PREDICTED_3_DAY_K_INDEX_URL)
    fetchPredictedKIndex(PREDICTED_K_INDEX_URL)
    fetchKIndex(K_INDEX_URL)
  }, [fetchPredicted3DayKIndex, fetchPredictedKIndex, fetchKIndex])

  const kIndex = {
    ...K_INDEX_CHART,
    name: 'K-Index',
    data: props.kIndex,
  }
  const predictedKIndex = {
    ...K_INDEX_CHART,
    name: 'Predicted 27 day K-Index',
    data: props.predictedKIndex,
  }
  const predicted3DayKIndex = {
    ...K_INDEX_CHART,
    name: 'Predicted 3 Day K-Index',
    data: props.predicted3DayKIndex,
    tooltip: {
      crosshairs: true,
      pointFormat: `<b>{%H:%M}</b><br/>K-Index: <b>{point.y} {point.g}</b>`,
    },
    dataLabels,
  }

  const { kIndexError, predictedKIndexError, predicted3DayKIndexError } = props

  return (
    <div>
      <div className="k-indices">
        <div className="observed">
          <Chart
            id="k-index"
            title="K-Index"
            series={kIndex}
            settings={K_INDEX_SETTINGS}
            error={kIndexError}
          />
        </div>
        <div className="predicted">
          <Chart
            id="predicted-3-day-k-index"
            title="Predicted 3 Day K-Index"
            series={predicted3DayKIndex}
            settings={K_INDEX_SETTINGS}
            error={predicted3DayKIndexError}
          />
        </div>
      </div>
      <Chart
        id="predicted-k-index"
        title="Predicted 27 day K-Index"
        series={predictedKIndex}
        settings={K_INDEX_SETTINGS}
        error={predictedKIndexError}
      />
    </div>
  )
}

interface KIndexChartContainerState {
  predictedKIndex: any
  predicted3DayKIndex: any
  kIndex: any
}

const mapState = (state: KIndexChartContainerState) => {
  const { predictedKIndex, predicted3DayKIndex, kIndex } = state
  return {
    predictedKIndex: predictedKIndex.data,
    predictedKIndexError: predictedKIndex.error,
    predicted3DayKIndex: predicted3DayKIndex.data,
    predicted3DayKIndexError: predicted3DayKIndex.error,
    kIndex: kIndex.data,
    kIndexError: kIndex.error,
  }
}

const mapDispatch = {
  fetchPredictedKIndex,
  fetchPredicted3DayKIndex,
  fetchKIndex,
}

// ToDo: Change to hooks api

const connector = connect(mapState, mapDispatch)

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(KIndexChartContainer)
